import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import Cookies from 'js-cookie';

const loginQuery = gql`
  query login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      success
      token
      errorMessageId
    }
  }
`;

const meQuery = gql`
  query me {
    me {
      id
      username
      roles {
        id
        name
      }
    }
  }
`;

function setTokenCookie(token, expires) {
  Cookies.set('id_token', token, { expires });
}

function getTokenCookie() {
  return Cookies.get('id_token');
}

function withLogin(WrappedComponent) {
  class LoginWrapper extends React.Component {
    static contextTypes = {
      client: PropTypes.object.isRequired,
    };

    constructor(props) {
      super(props);

      this.login = this.login.bind(this);
    }

    async login(username, password, rememberMe) {
      const response = await this.context.client.query({
        query: loginQuery,
        variables: {
          username,
          password,
        },
        fetchPolicy: 'network-only',
      });
      if (response.data.login.success) {
        if (rememberMe) {
          setTokenCookie(response.data.login.token, 365 * 1000);
        } else {
          setTokenCookie(response.data.login.token, 7);
        }
      }
      return response;
    }

    render() {
      return <WrappedComponent login={this.login} {...this.props} />;
    }
  }

  return LoginWrapper;
}

export { withLogin, getTokenCookie, loginQuery, meQuery };
